import { SystemGuid } from '../../../../constants';

export enum NewPatientMessageTypeEnum {
  Phone = 'Phone',
  Task = 'Task',
  RxRefillRequest = 'RxRefillRequest',
  VaccineAdministration = 'VaccineAdministration',
  Amendment = 'Amendment',
  Authorization = 'Authorization',
  PatientLabOrder = 'PatientLabOrder',
  FacilityPortal = 'FacilityPortal',
  PatientPortal = 'PatientPortal',
}

export const NewPatientMessageTypeLabels = {
  [NewPatientMessageTypeEnum.Phone]: 'New Msg: Phone',
  [NewPatientMessageTypeEnum.Task]: 'New Msg: Task',
  [NewPatientMessageTypeEnum.RxRefillRequest]: 'New Msg: RxRefillRequest',
  [NewPatientMessageTypeEnum.VaccineAdministration]: 'New Msg: VaccineAdmin',
  [NewPatientMessageTypeEnum.Amendment]: 'New Msg: Amendment',
  [NewPatientMessageTypeEnum.Authorization]: 'New Msg: Authorization',
  [NewPatientMessageTypeEnum.PatientLabOrder]: 'New Msg: LabOrder',
  [NewPatientMessageTypeEnum.FacilityPortal]: 'New Msg: FacilityPortal',
  [NewPatientMessageTypeEnum.PatientPortal]: 'New Msg: PatientPortal',
} as const;


export const PatientMessageTypeLabels = {
  [NewPatientMessageTypeEnum.Phone]: 'Phone Message',
  [NewPatientMessageTypeEnum.Task]: 'Task Message',
  [NewPatientMessageTypeEnum.RxRefillRequest]: 'RxRefill Request Message',
  [NewPatientMessageTypeEnum.VaccineAdministration]: 'Vaccine Admin Message',
  [NewPatientMessageTypeEnum.Amendment]: 'Amendment Message',
  [NewPatientMessageTypeEnum.Authorization]: 'Authorization Message',
  [NewPatientMessageTypeEnum.PatientLabOrder]: 'Patient Lab Order Message',
  [NewPatientMessageTypeEnum.FacilityPortal]: 'Facility Portal Message',
  [NewPatientMessageTypeEnum.PatientPortal]: 'Patient Portal Message',
} as const;

export const TitleOfMessageLabelsMacroEditor = {
  [NewPatientMessageTypeEnum.Phone]: 'New Phone',
  [NewPatientMessageTypeEnum.Task]: 'New Task',
  [NewPatientMessageTypeEnum.RxRefillRequest]: 'New RxRefill Request',
  [NewPatientMessageTypeEnum.VaccineAdministration]: 'New Vaccine Admin',
  [NewPatientMessageTypeEnum.Amendment]: 'New Amendment',
  [NewPatientMessageTypeEnum.Authorization]: 'New Authorization',
  [NewPatientMessageTypeEnum.PatientLabOrder]: 'New Patient Lab Order',
  [NewPatientMessageTypeEnum.FacilityPortal]: 'New Facility Portal',
  [NewPatientMessageTypeEnum.PatientPortal]: 'New Patient Portal',
} as const;

const systemGuid = new SystemGuid();

export const MessageTypeValue = (messageType: string): NewPatientMessageTypeEnum | null => {
  switch (messageType) {
      case systemGuid.TCMessageType:
      return NewPatientMessageTypeEnum.Phone;
    case systemGuid.TaskMessageType:
      return NewPatientMessageTypeEnum.Task;
    case systemGuid.AmendmentMessageType:
      return NewPatientMessageTypeEnum.Amendment;
    case systemGuid.VaccineAdministrationMessageType:
      return NewPatientMessageTypeEnum.VaccineAdministration;
    case systemGuid.AuthorizationMessageType:
      return NewPatientMessageTypeEnum.Authorization;
    case systemGuid.PatientLabOrderMessageType:
      return NewPatientMessageTypeEnum.PatientLabOrder;
    case systemGuid.RxRefillRequestMessageType:
      return NewPatientMessageTypeEnum.RxRefillRequest;
    default:
      return null;
  };
};

export const IsImplementedMessageTypeValue = (messageType: string): boolean => {
  if(MessageTypeValue(messageType) !== null) {
    return true;
  }

  return false;
};
